/* app/js/src/components/channel/channel-wizard/step1/substep2.scss */
.cursor-pointer {
  cursor: pointer;
}
.small-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.small-container .text {
  color: #232f3a;
}
.small-container .text .info {
  margin-top: 25px;
  font-size: 12px;
  color: #879baf;
}
.small-container {
  margin-bottom: 12px;
}
.small-container .position-value {
  display: flex;
  align-items: center;
}
.advanced-settings {
  display: flex;
  align-items: center;
  margin-bottom: 15vh;
  min-width: 650px;
  justify-content: space-between;
}
.checkbox-input {
  background-color: #ffffff;
  position: relative;
  margin-top: 34px;
  line-height: 30px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
}
.checkbox-input.active div svg {
  fill-opacity: 1;
}
.checkbox-input-div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-right: 15px;
}
.checkbox-input-div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: 1.8px;
  bottom: 0;
  left: 0;
  right: 0;
  fill-opacity: 0;
}
/*# sourceMappingURL=substep2.css.map */
